import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { ItemAttribute } from '../../models/item';
import { ItemAttributeCreatePayload } from '../item-attributes/item-attributes-store.service';

@Injectable()
export class ItemAttributesService {
  constructor(private http: ApiClient) {}

  getAll(itemId: number) {
    return this.http.get<ItemAttribute[]>(`items/${itemId}/attributes`);
  }

  update(itemId: number, attributesId, attribute: Partial<ItemAttribute>) {
    return this.http.put(
      `items/${itemId}/attributes/${attributesId}`,
      attribute
    );
  }

  create(itemId: number, attribute: ItemAttributeCreatePayload) {
    return this.http.post<ItemAttribute>(
      `items/${itemId}/attributes`,
      attribute
    );
  }

  delete(itemId: number, attributeId: number) {
    return this.http.delete(`items/${itemId}/attributes/${attributeId}`);
  }

  setValue(itemId: number, attributeId: number, value: string) {
    return this.http.post(`items/${itemId}/attributes/${attributeId}/value`, {
      value
    });
  }

  eventInsert(
    itemId: number,
    eventInsert: {
      promptable_id: number;
      attributes: { attribute_id: number; value: string }[];
      promptable_type: 'hireItem' | 'workshopJob';
      event: any;
    }
  ) {
    return this.http.post(
      `items/${itemId}/attributes/event-insert`,
      eventInsert
    );
  }
}
